import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const RegenBrakingSimulatorGuidePage = () => <DataDrivenGuidePage slug="guide-regen-braking-simulator" />;

export default RegenBrakingSimulatorGuidePage;
